import { useMemo } from "react"
import useOpus from "contexts/opus/hooks/use-opus"
import { EUserGroups } from "platform-client/types"
import { getUserTokenValue } from "utils/pocketknife/get-user-token-value"
import { EOpusPermission } from "./use-opus-permissions"

/**
 * Whether the signed-in user belongs to a broker (any broker role), based on
 * the `grouptype` claim in the Opus token. Stella agents and admins are
 * `Insurer` / `InsurerAdministrator`.
 */
export const useIsBrokerUser = (): boolean => {
  const { opusToken } = useOpus()

  return useMemo(() => {
    try {
      return (
        getUserTokenValue(EOpusPermission.GroupType, opusToken) ===
        EUserGroups.Distributor
      )
    } catch (error) {
      // An undecodable token carries no permissions, so the cancellation
      // controls this gates aren't rendered anyway.
      return false
    }
  }, [opusToken])
}
